import { Route, RouteProps } from "react-router-dom";
import Unauthorized from "screens/Shared/Unauthorized";
import { useEffect } from "react";
import history from "utils/history";
import viewpaths from "global/constants/ViewPathConstants";
import { useHasAccess } from "layouts/Config";

interface CustomProps extends RouteProps {
  component?: any;
  isLoggedIn: boolean;
  componentProps: any;
}

const AuthGuard = (props: CustomProps) => {
  const { component: Component, isLoggedIn, path, ...rest } = props;
  const hasAccess = useHasAccess(path!.toString());

  useEffect(() => {
    if (!isLoggedIn) {
      history.push(viewpaths.loginViewPath);
    }
  }, [isLoggedIn]);

  return (
    <Route
  {...rest}
  render={(routeProps) =>
    isLoggedIn && hasAccess ? (
      <Component {...routeProps} {...props.componentProps} />
    ) : (
      <Unauthorized />
    )
  }
/>
  );
};

export default AuthGuard;
